import React from "react";
import { captureError } from "./grafana";
import { captureSentryError } from "./sentry";

interface ErrorBoundaryProps {
  fallback: React.ReactNode;
  onReset?: () => void;
  children: React.ReactNode;
}

interface ErrorBoundaryState {
  hasError: boolean;
  error: Error | null;
}

export class ObservabilityErrorBoundary extends React.Component<ErrorBoundaryProps, ErrorBoundaryState> {
  constructor(props: ErrorBoundaryProps) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error: Error): ErrorBoundaryState {
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo): void {
    captureError(error, { componentStack: errorInfo.componentStack || "" });
    captureSentryError(error, { componentStack: errorInfo.componentStack || "" });
  }

  resetError = (): void => {
    this.setState({ hasError: false, error: null });
    this.props.onReset?.();
  };

  render(): React.ReactNode {
    if (this.state.hasError) {
      return this.props.fallback;
    }
    return this.props.children;
  }
}

// Backward compatibility alias
export const SentryErrorBoundary = ObservabilityErrorBoundary;
